// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.bs.mjs";
import * as Belt_Id from "rescript/lib/es6/belt_Id.js";
import * as LumiJzon from "./LumiJzon.bs.mjs";
import * as Core__Date from "@rescript/core/lib/es6/src/Core__Date.bs.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as StringCodec from "./StringCodec.bs.mjs";
import * as Core__Option from "@rescript/core/lib/es6/src/Core__Option.bs.mjs";
import * as Core__Result from "@rescript/core/lib/es6/src/Core__Result.bs.mjs";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";
import SubDays from "date-fns/subDays";
import SubYears from "date-fns/subYears";
import SubMonths from "date-fns/subMonths";

function since(date) {
  return Date.now() - date.getTime();
}

function dateWireFormat(date) {
  return date.toISOString().substring(0, 10);
}

function cmp(a, b) {
  return Core__Date.compare(a, b) | 0;
}

var Cmp = Belt_Id.MakeComparableU({
      cmp: cmp
    });

function toString(date) {
  return date.toISOString();
}

function fromString(str) {
  var date = new Date(str);
  if (isNaN(date.getTime())) {
    return {
            TAG: "Error",
            _0: "Invalid date: " + str
          };
  } else {
    return {
            TAG: "Ok",
            _0: date
          };
  }
}

function stringCodec_fromString(str) {
  return Core__Result.mapOr(fromString(str), undefined, (function (v) {
                return Caml_option.some(v);
              }));
}

var stringCodec = {
  toString: toString,
  fromString: stringCodec_fromString
};

var jsonCodec = Jzon.custom((function (date) {
        return Jzon.encodeWith(date.toISOString(), Jzon.string);
      }), (function (json) {
        return Core__Result.map(Jzon.decodeWith(json, Jzon.string), (function (prim) {
                      return new Date(prim);
                    }));
      }));

function copy(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}

var $$Date$1 = {
  toString: toString,
  fromString: fromString,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec,
  copy: copy
};

var Private = {
  $$Date: $$Date$1
};

function toString$1(prim) {
  return prim.toISOString();
}

function fromString$1(str) {
  var date = new Date(str);
  if (isNaN(date.getTime())) {
    return {
            TAG: "Error",
            _0: "Invalid date: " + str
          };
  } else {
    return {
            TAG: "Ok",
            _0: date
          };
  }
}

var jsonCodec$1 = Jzon.custom((function (date) {
        return Jzon.encodeWith(date.toISOString(), Jzon.string);
      }), (function (json) {
        return Core__Result.map(Jzon.decodeWith(json, Jzon.string), (function (prim) {
                      return new Date(prim);
                    }));
      }));

var DateTime = {
  toString: toString$1,
  fromString: fromString$1,
  jsonCodec: jsonCodec$1
};

function first(dates) {
  if (dates.length !== 0) {
    return Caml_option.some(new Date(Caml_splice_call.spliceApply(Math.min, [dates.map(function (prim) {
                              return prim.getTime();
                            })])));
  }
  
}

function last(dates) {
  if (dates.length !== 0) {
    return Caml_option.some(new Date(Caml_splice_call.spliceApply(Math.max, [dates.map(function (prim) {
                              return prim.getTime();
                            })])));
  }
  
}

function toSeconds(duration) {
  if (duration.TAG === "Seconds") {
    return duration._0;
  } else {
    return duration._0 / 1e6;
  }
}

function fromSeconds(s) {
  return {
          TAG: "Seconds",
          _0: s
        };
}

function toMicroseconds(duration) {
  if (duration.TAG === "Seconds") {
    return duration._0 * 1e6;
  } else {
    return duration._0;
  }
}

function fromMicroseconds(us) {
  return {
          TAG: "Microseconds",
          _0: us
        };
}

var seconds = Jzon.custom((function (duration) {
        return Jzon.encodeWith(toSeconds(duration), Jzon.$$float);
      }), (function (json) {
        return Core__Result.map(Jzon.decodeWith(json, Jzon.$$float), fromSeconds);
      }));

var microseconds = Jzon.custom((function (duration) {
        return Jzon.encodeWith(toMicroseconds(duration), Jzon.$$float);
      }), (function (json) {
        return Core__Result.map(Jzon.decodeWith(json, Jzon.$$float), fromMicroseconds);
      }));

var JsonCodecs = {
  seconds: seconds,
  microseconds: microseconds
};

var Duration = {
  toSeconds: toSeconds,
  fromSeconds: fromSeconds,
  toMicroseconds: toMicroseconds,
  fromMicroseconds: fromMicroseconds,
  JsonCodecs: JsonCodecs
};

function toDate(date) {
  return date;
}

function unsafeFromDate(date) {
  return date;
}

function fromDateNoCopy(date) {
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function fromDate(date) {
  var _date = copy(date);
  return fromDateNoCopy(_date);
}

function mapDate(day, f) {
  return f(day);
}

function make() {
  var date = new Date();
  return fromDateNoCopy(date);
}

function makeWithYMD(year, month, date) {
  return fromDateNoCopy(new Date(year, month, date));
}

function stringCodec_toString(date) {
  return date.toISOString().substring(0, 10);
}

function stringCodec_fromString$1(str) {
  return Core__Option.map(stringCodec_fromString(str), fromDate);
}

var stringCodec$1 = {
  toString: stringCodec_toString,
  fromString: stringCodec_fromString$1
};

var jsonCodec$2 = LumiJzon.stringCodec(stringCodec$1);

function subDays(day, days) {
  return mapDate(day, (function (date) {
                return SubDays(date, days);
              }));
}

var Day_toString = stringCodec_toString;

var Day_fromString = stringCodec_fromString$1;

var Day = {
  toDate: toDate,
  unsafeFromDate: unsafeFromDate,
  fromDateNoCopy: fromDateNoCopy,
  fromDate: fromDate,
  mapDate: mapDate,
  make: make,
  makeWithYMD: makeWithYMD,
  stringCodec: stringCodec$1,
  toString: Day_toString,
  fromString: Day_fromString,
  jsonCodec: jsonCodec$2,
  subDays: subDays
};

function fromDate$1(date) {
  return date;
}

function toDate$1(date) {
  return date;
}

function make$1() {
  return new Date();
}

function copy$1(date) {
  return copy(date);
}

function getFullYear(date) {
  return date.getUTCFullYear();
}

function getMonth(date) {
  return date.getUTCMonth();
}

function sameYear(x, y) {
  var xYear = x.getUTCFullYear();
  var yYear = y.getUTCFullYear();
  return xYear === yYear;
}

function sameMonth(x, y) {
  var xMonth = x.getUTCMonth();
  var yMonth = y.getUTCMonth();
  if (xMonth === yMonth) {
    return sameYear(x, y);
  } else {
    return false;
  }
}

function showMonth(month) {
  return month.getUTCFullYear().toString() + "-" + (month.getUTCMonth() + 1 | 0).toString();
}

function showYear(year) {
  return year.getUTCFullYear().toString();
}

function subMonths(date, months) {
  return SubMonths(date, months);
}

function subYears(date, years) {
  return SubYears(date, years);
}

function setMonth(date, m) {
  date.setUTCMonth(m);
}

function setDate(date, d) {
  date.setUTCDate(d);
}

function setHoursMSMs(date, hours, minutes, seconds, milliseconds) {
  date.setUTCHours(hours, minutes, seconds, milliseconds);
}

function startOfMonth(date) {
  var _date = copy$1(date);
  setDate(_date, 1);
  setHoursMSMs(_date, 0, 0, 0, 0);
  return _date;
}

function startOfYear(date) {
  var _date = copy$1(date);
  setMonth(_date, 0);
  setDate(_date, 1);
  setHoursMSMs(_date, 0, 0, 0, 0);
  return _date;
}

var stringCodec$2 = StringCodec.map(stringCodec, (function (x) {
        return Caml_option.some(x);
      }), toDate$1);

var jsonCodec$3 = LumiJzon.stringCodec(stringCodec$2);

var UTCDate_toString = stringCodec$2.toString;

var UTCDate_fromString = stringCodec$2.fromString;

var UTCDate = {
  fromDate: fromDate$1,
  toDate: toDate$1,
  make: make$1,
  copy: copy$1,
  getFullYear: getFullYear,
  getMonth: getMonth,
  sameYear: sameYear,
  sameMonth: sameMonth,
  showMonth: showMonth,
  showYear: showYear,
  subMonths: subMonths,
  subYears: subYears,
  setMonth: setMonth,
  setDate: setDate,
  setHoursMSMs: setHoursMSMs,
  startOfMonth: startOfMonth,
  startOfYear: startOfYear,
  stringCodec: stringCodec$2,
  toString: UTCDate_toString,
  fromString: UTCDate_fromString,
  jsonCodec: jsonCodec$3
};

var $$Date$2;

export {
  since ,
  dateWireFormat ,
  Cmp ,
  Private ,
  DateTime ,
  first ,
  last ,
  Duration ,
  Day ,
  UTCDate ,
  $$Date$2 as $$Date,
}
/* Cmp Not a pure module */
